import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { RequestModel } from '../interfaces/RequestModel';
import { observeOn, catchError, map, retry } from 'rxjs/operators';
//import { stringify } from 'querystring';
import { throwError, Observable, of, EMPTY } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { Order, Address } from '../interfaces/order';
import { token_response } from '../interfaces/token_response';
import { JsonResult } from '../interfaces/JsonResult';
import { Router } from '@angular/router';
import { Store } from '../interfaces/Store';


@Injectable({
    providedIn: 'root'
})
export class ApiService {


    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    constructor(private httpClient: HttpClient,
                private router: Router
    ) {
        //  this.getHeaders(false);
    }

    // getHeaders(authorized: boolean): HttpHeaders {
    //    if (authorized) {
    //        if (localStorage.getItem('access_token')) {
    //            this.autorize = 'bearer ' + localStorage.getItem('access_token');
    //            return this.httpOptions = new HttpHeaders({
    //                'Content-Type': 'application/json',
    //                //'Accept': '*/*',
    //                'Authorization': this.autorize,
    //                'Access-Control-Allow-Origin': environment.origin
    //            });
    //        } else {
    //            // this.router.navigate(['/account/login']);
    //        }
    //    } else {
    //        return this.httpOptions = new HttpHeaders({
    //            'Content-Type': 'application/json',
    //            'Accept': '*/*',
    //            'Access-Control-Allow-Credentials': 'true',
    //            'Access-Control-Allow-Origin':  environment.origin,
    //            'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
    //            'Access-Control-Allow-Headers': 'OAccess-Control-Allow-Origin, Content-Type, Accept, Accept-Language, Origin, User-Agent'
    //        });
    //    }
    // }

    subscribe(model: any): Observable<any> {


        return this.httpClient
            .post<any>(`${environment.apiUrl}/api/site/Subscription`, model,
                this.httpOptions)
            .pipe(

                map(o => {

                    console.log(o);

                    return o;
                })

            );
    }
    // change password
    ChangePassword(newpassword: string, password: string): Observable<any> {


        return this.httpClient
            .post<JsonResult>(`${environment.apiUrl}/api/user/changepassword`,
                {
                    NewPassword: newpassword,
                    Password: password
                },
                this.httpOptions)
            .pipe(

                map(user => {

                    console.log(user);

                    return user;
                })

            );
    }


    UpdateProfile(model: any): Observable<JsonResult> {
        return this.httpClient
            .post<JsonResult>(`${environment.apiUrl}/api/user/update`, model, this.httpOptions)
            .pipe(

                map(user => {

                    console.log(user);

                    return user;
                })

            );
    }

    sendEmail(model: any): Observable<JsonResult> {
        return this.httpClient
            .post<JsonResult>(`${environment.apiUrl}/api/site/contact`, model, this.httpOptions)
            .pipe(

                map(user => {

                    console.log(user);

                    return user;
                })

            );
    }

    // change password
    PostOrder(model: any): Observable<any> {


        return this.httpClient
            .post<JsonResult>(`${environment.apiUrl}/api/shopping/post`, model)
            .pipe(

                map(o => {

                    console.log(o);

                    return o;
                })

            );
    }

    // delete address
    DeleteAddress(id: number): Observable<any> {

        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
                // 'Accept': '*/*',
                // 'Access-Control-Allow-Origin': environment.origin
            })
        };

        return this.httpClient
            .post<JsonResult>(`${environment.apiUrl}/api/address/delete?id=${id}`, null, httpOptions)
            .pipe(

                map(o => {

                    console.log(o);

                    return o;
                })

            );
    }
    // update address
    UpdateAddress(address): Observable<JsonResult> {


        return this.httpClient
            .post<JsonResult>(`${environment.apiUrl}/api/address/Update`, address)
            .pipe(

                map(o => {

                    console.log(o);
                    return o;
                })

            );
    }
    // add address
    AddAddress(address: Address): Observable<any> {
        return this.httpClient
            .post<JsonResult>(`${environment.apiUrl}/api/address/post`, address)
            .pipe(

                map(o => {

                    console.log(o);

                    return o;
                })

            );
    }

    // get filter by category id
    public getOrders(): Observable<any> {
        return this.httpClient.get<any>(`${environment.apiUrl}/api/user/getorders`);
    }
    public getOrder(id): Observable<any> {
        return this.httpClient.get<any>(`${environment.apiUrl}/api/user/getorder?id=${id}`);
    }

    public getTransaction(): Observable<any> {
        return this.httpClient.get(`${environment.apiUrl}/api/user/gettransactions`);
    }

    // get WALLETS
    public getWallets() {
        return this.httpClient.get(`${environment.apiUrl}/api/wallet/get`).pipe(
            retry(3),
            catchError(() => {
                return EMPTY;
            }),
            shareReplay()
        );
    }

    // get address of user
    public getAddrerss() {
        return this.httpClient.get<any>(`${environment.apiUrl}/api/address/getall`);
    }

    // get store
    public getStore(): Observable<Store> {
        // get language : en|fa|...
        const detectedLanguage = localStorage.getItem('lan') || 'EN';
        localStorage.setItem('lan', detectedLanguage);
        const lang = detectedLanguage;
        return this.httpClient.get<Store>(`${environment.apiUrl}/api/site/getconfig/` + lang)
            .pipe(

                map(o => {


                    return o;
                })

            );
    }

    // get filter by category id
    public getFilter(id: number) {
        return this.httpClient.get(`${environment.apiUrl}/api/category/filter?selectedid=${id}`);
    }

    // get product
    // i have this work fine
    public getProductsBy(param: RequestModel) {
        return this.httpClient.post(`${environment.apiUrl}/api/product/search`, param);
    }

    public getRoute(route: string): Observable<any> {
        return this.httpClient.get<any>(`${environment.apiUrl}/api/${route}`);
    }

    public getText(route: string) {
        return this.httpClient.get(`${environment.apiUrl}/api/textcontent/getbyrout?route=${route}`);
    }

    public getUser(): Observable<any> {
        return this.httpClient.get(`${environment.apiUrl}/api/user/get`)
            .pipe(
                retry(1),
                catchError(this.errorHandl)
            );
    }

    public getDashboard(): Observable<any> {
        return this.httpClient.get(`${environment.apiUrl}/api/user/GetDashboard`)
            .pipe(
                retry(1),
                catchError(this.errorHandl)
            );
    }
    // get product
    public getProducts() {
        return this.httpClient.get(`${environment.apiUrl}/api/product/Bestsellers`);
    }
    // get product
    public getProduct(id: number) {
        return this.httpClient.get(`${environment.apiUrl}/api/product/getsingle/${id}`);
    }
    // get menu
    public getMenu() {

        return this.httpClient.get(`${environment.apiUrl}/api/product/menu`);
    }
    // get product
    public getCategories() {
        return this.httpClient.get(`${environment.apiUrl}/api/category/get`);
    }
    public getDepartment() {
        return this.httpClient.get(`${environment.apiUrl}/api/category/department`);
    }
    // Error handling
    errorHandl(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }

}
